import { ChangePasswordView } from 'features/auth';

const ChangePasswordPage = () => <ChangePasswordView />;

export default ChangePasswordPage;
